module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h2', {
    staticClass: "Verse-head",
    attrs: {
      "id": "_idParaDest-8"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  }), _vm._v("Absent Wells")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Not in broken")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("fragments")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("of head-birth gods ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("temping as the real thing")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("nor tamed ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("box-brain infobees")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("buzzing loudly")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("in the head,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("but,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("the singing beauty")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("of a world set free")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("sagas of the rending heart")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("laments like tears falling")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("on dried ashes of the soul")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("wounded cries embracing ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("the teeming fount")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("of present loves")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("and breeding grounds")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("of hope.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Such roots")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("struck in fertile ground")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("grow like trees of life")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("fruit-laden, green leaves")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("fed and watered, circled")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("by the dark aura")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("of the light-clad mystery")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("of our ever-present")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("absent God.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-375b4824","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781398400801_EPUB-10.vue
// module id = 87
// module chunks = 0